export default (conversationId: string) => {
  try {
    return conversationId ? /^\d+$/.test(conversationId) && conversationId.length <= 19 : false;
  } catch {
    return false;
  }
};
